// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gqnaN8RudTOdxw {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 8px;\n}\n.gqnaN8RudTOdxw:focus {\n  /*\n    TODO\n    Ideally we want to remove the global :focus override from classic.\n    It hurts accessibility and forces us to do stuff like this.\n    Once it is done, this can be removed.\n  */\n  outline: black dotted 1px;\n}\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .gqnaN8RudTOdxw:focus {\n    outline: -webkit-focus-ring-color auto 5px;\n  }\n}\n.TScnIQPbkMQo_l {\n  width: unset;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": "gqnaN8RudTOdxw",
	"boardCard": "TScnIQPbkMQo_l"
};
export default ___CSS_LOADER_EXPORT___;
